import { Component, Input, OnInit } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FieldConfig } from '@smartflip/data-models';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lib-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss'],
  imports: [ReactiveFormsModule, IonicModule],
})
export class AutoCompleteComponent implements OnInit {
  @Input() group: UntypedFormGroup;
  @Input() field: FieldConfig;

  isOpen = false;
  allOptions: Record<string, string>[] = [];
  filteredOptions: Record<string, string>[] = [];

  ngOnInit() {
    this.allOptions = this.getFieldOptions(this.field);
    this.filteredOptions = [...this.allOptions];
  }

  public getFieldOptions(field: FieldConfig) {
    return field.options.map((option) => option as Record<string, string>);
  }

  public filterOptions(event: CustomEvent) {
    // Safely access the value property, handling Ionic's event structure
    const value = event?.detail?.value;
    const query = typeof value === 'string' ? value.toLowerCase() : '';
    this.isOpen = !!query;

    if (!query) {
      this.filteredOptions = [...this.allOptions];
      return;
    }

    this.filteredOptions = this.allOptions.filter((option) =>
      option['displayText'].toLowerCase().includes(query),
    );
  }

  public selectOption(value: string) {
    this.group.get(this.field.name).setValue(value);
    this.isOpen = false;
  }
}
